<script lang="ts" setup>
import {RouterView} from 'vue-router'
import router from "@/router/router.ts";
import {useDialogStore} from "@/stores/dialog.store.ts";
import {useSynchroStore} from "@/stores/synchro.store.ts";
import {RouteEnum} from "@/router/RouteEnum.ts";

const dialogStore = useDialogStore()

function onCloseClick() {
  window.close()
  router.push({name: RouteEnum.Dashboard})
}
</script>

<template>
  <v-app>
    <div
      v-if="useSynchroStore().isFetching"
      id="loader"
      class="w-100 text-center pt-16"
    >
      <v-progress-linear
        color="blue"
        height="5"
        indeterminate
      />
    </div>
    <v-app-bar>
      <slot name="default">
        <div class="d-flex w-100 justify-space-between text-center align-center">
          <div class="pl-5 text-h6">
            Synchronisation
          </div>
          <router-view name="headerCenter"/>
          <div style="width:150px;" class="text-right">
            <v-btn icon @click="onCloseClick()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </div>
      </slot>
    </v-app-bar>
    <v-main>
      <RouterView/>
      <RouterView name="body"/>
    </v-main>
    <v-dialog
      v-model="dialogStore.show"
      max-width="500"
    >
      <v-alert
        v-model="dialogStore.show"
        :border-color="dialogStore.level"
        :text="dialogStore.text"
        :title="dialogStore.title"
        border="start"
        closable
      />

    </v-dialog>
  </v-app>
</template>

<style lang="scss" scoped>
#loader {
  position: absolute;
  top: var(--v-layout-top);
  z-index: 1005;
}
</style>
